// export const decryptedUserPrivileges = decryptList(
//   JSON.parse(localStorage.getItem("pv01") || "[]")
// );
// export const anncouncementPrivileges = {
//   create: decryptedUserPrivileges.includes("LP001"),
//   update: decryptedUserPrivileges.includes("LP002"),
//   delete: decryptedUserPrivileges.includes("LP003"),
// };

export const getAnnouncementPrivileges = (privileges: string[]) => ({
  create: privileges.includes("LP001"),
  update: privileges.includes("LP002"),
  delete: privileges.includes("LP003"),
});

export const getClientsPrivileges = (privileges: string[]) => ({
  create: privileges.includes("CL001"),
  update: privileges.includes("CL002"),
  disable: privileges.includes("CL003"),
  generateClientSecret: privileges.includes("CL004"),
  assignProducts: privileges.includes("CL005"),
  resend: privileges.includes("CL006"),
});

export const getProductsPrivileges = (privileges: string[]) => ({
  create: privileges.includes("PR001"),
  update: privileges.includes("PR002"),
  deactivate: privileges.includes("PR003"),
});

export const getFacilityPrivileges = (privileges: string[]) => ({
  view: privileges.includes("FA000"),
  create: privileges.includes("FA001"),
  update: privileges.includes("FA002"),
  disable: privileges.includes("FA003"),
  resend: privileges.includes("FA004"),
});

export const getGroupAdminPrivileges = (privileges: string[]) => ({
  invite: privileges.includes("GA001"),
  update: privileges.includes("GA002"),
  lock: privileges.includes("GA003"),
  resend: privileges.includes("GA004"),
  delete: privileges.includes("GA005"),
});

export const getFacilityUserPrivileges = (privileges: string[]) => ({
  invite: privileges.includes("FU001"),
  lock: privileges.includes("FU002"),
  delete: privileges.includes("FU003"),
  reset: privileges.includes("FU004"),
  resend: privileges.includes("FU005"),
  update: privileges.includes("FU006"),
});

export const getBizboxUserPrivileges = (privileges: string[]) => ({
  createNewCoAdmin: privileges.includes("BU001"),
  create: privileges.includes("BU002"),
  edit: privileges.includes("BU003"),
  lock: privileges.includes("BU004"),
  resend: privileges.includes("BU005"),
  delete: privileges.includes("BU006"),
});

export const getManageAccessPrivileges = (privileges: string[]) => ({
  assign: privileges.includes("MA001"),
});
